var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shows)?_c('BaseSection',{attrs:{"padded":""}},[_c('ShowScheduleBlock',{attrs:{"shows":_vm.shows}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }